import { render, staticRenderFns } from "./TransferenciaTecnologica.vue?vue&type=template&id=6cca3e70&"
import script from "./TransferenciaTecnologica.vue?vue&type=script&lang=js&"
export * from "./TransferenciaTecnologica.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports